import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { applyToken } = useAuth();

  useEffect(() => {
    const hash = window.location.hash || "";
    const m = hash.match(/token=([^&]+)/);
    if (m && m[1]) {
      applyToken(decodeURIComponent(m[1])).then(() => navigate("/", { replace: true }));
    } else {
      navigate("/login?error=ms_notoken", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
      <Loader2 className="h-5 w-5 animate-spin mr-2" /> Signing you in…
    </div>
  );
}
